import { useMemo, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { projectThunks } from 'store/features/project/thunks'
import { projectSelectors } from 'store/features/project/selectors'
import ArrowDownIcon from 'assets/svgr-icons/Arrow_Down.svg'
import { Flyout } from 'common-components'
import { Tooltip } from 'components/Tooltip'
import { useResponsive } from 'hooks/useResponsive'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { translate } from 'utils/translations'
import * as Styled from './styled'
import ExportOptions from './ExportOptions'
import { T } from 'consts/translationKeys'
import { dispatch } from 'store'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { BOTTOM } from 'components/Tooltip/consts'
import { userSelectors } from 'store/features/user/selectors'
import { TUserPlan, USER_PLAN_TO_QUALITIES } from 'consts/user'

const ExportButton: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false)

  const buttonRef = useRef<HTMLButtonElement>(null)

  const { uid } = useSelector(projectSelectors.data)

  const { projectId = '' } = useParams()
  const isMobile = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)
  const subscription = useSelector(userSelectors.userCurrentPlanId)
  const isDisabled = useSelector(projectDataSelectors.isExportDisabled)
  const hasPendingMediaItem = useSelector(
    projectDataSelectors.hasPendingMediaItem
  )
  const isExportTooltipVisible = hasPendingMediaItem && !isMobile

  const allowedQualities = useMemo(
    () => USER_PLAN_TO_QUALITIES[subscription as TUserPlan],
    [subscription]
  )

  const toggleFlyout = () => setIsOpen(prev => !prev)

  const onClose = () => {
    setIsOpen(false)
  }

  const handleExport = (quality: number) => {
    dispatch(
      projectThunks.renderProject({
        projectId,
        quality,
        uid
      })
    )
    onClose()
  }

  return (
    <>
      <Tooltip
        position={BOTTOM}
        tooltipText={translate(T.EXPORT_DISABLE_LABEL)}
        isVisible={isExportTooltipVisible}
      >
        <div>
          <Styled.ExportButtonWrapper
            ref={buttonRef}
            onClick={toggleFlyout}
            $isDisabled={isDisabled}
          >
            {translate(T.EXPORT_LABEL)}
            <ArrowDownIcon />
          </Styled.ExportButtonWrapper>
        </div>
      </Tooltip>
      {isMobile ? (
        <Styled.ExportOptionsSlideUp
          isOpen={isOpen}
          onClose={onClose}
          bottomMargin={0}
        >
          <ExportOptions
            onExport={handleExport}
            allowedQualities={allowedQualities}
          />
        </Styled.ExportOptionsSlideUp>
      ) : (
        <Flyout
          isOpen={isOpen}
          anchorEl={buttonRef.current}
          onClose={onClose}
          options={{
            position: 'bottom',
            alignmentX: 'right',
            extraOffset: 8
          }}
        >
          <ExportOptions
            onExport={handleExport}
            allowedQualities={allowedQualities}
          />
        </Flyout>
      )}
    </>
  )
}

export default ExportButton
